module.exports = __webpack_public_path__ + "img/logo_entretantocuento.edf09b90.svg";